import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { useLanguage } from "@/i18n/LanguageContext";

export const EMAIL = "support@playshub.net";

const Contact = () => {
  const { toast } = useToast();
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard?.writeText(EMAIL);
    setCopied(true);
    toast({ title: t.toasts.emailCopiedTitle, description: EMAIL });
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-[#F4F4F2]">
      <section id="contact" data-testid="contact-section" className="py-8 md:py-10">
        <div className="max-w-[1320px] mx-auto px-6 lg:px-8">
          <div className="flex flex-col items-center gap-12">
            <div className="reveal w-full max-w-2xl">
              <div className="text-[#2E4FE6] font-bold text-xs tracking-[0.22em] uppercase mb-5">{t.contact.eyebrow}</div>
              <h2 className="font-display text-[clamp(2.4rem,5vw,4.2rem)] uppercase text-[#111]">{t.contact.title}</h2>
              <p className="mt-6 text-lg text-neutral-600 max-w-lg mx-auto leading-relaxed">{t.contact.paragraph}</p>
            </div>
            <div className="reveal space-y-5 w-full max-w-2xl">
              <div className="bg-white rounded-lg p-7 border border-neutral-100">
                <div className="text-xs font-bold tracking-[0.18em] uppercase text-neutral-400 mb-3">{t.contact.writeLabel}</div>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
                  <a href={`mailto:${EMAIL}`} data-testid="contact-email-mailto" className="text-[#2E4FE6] font-semibold text-lg whitespace-nowrap hover:underline">
                    {EMAIL}
                  </a>
                  <button
                    onClick={copyEmail}
                    data-testid="contact-copy-email-button"
                    className="shrink-0 inline-flex items-center gap-1.5 text-sm font-medium text-neutral-600 hover:text-[#111] border border-neutral-200 rounded-md px-3 py-1.5 transition-colors"
                  >
                    {copied ? <Check className="w-4 h-4 text-green-600" /> : <Copy className="w-4 h-4" />}
                    {copied ? t.contact.copied : t.contact.copy}
                  </button>
                </div>
              </div>
              <div className="bg-white rounded-lg p-7 border border-neutral-100">
                <div className="text-xs font-bold tracking-[0.18em] uppercase text-neutral-400 mb-3">{t.contact.responseLabel}</div>
                <div className="text-[#111] font-semibold" data-testid="contact-sla-badge">
                  {t.contact.responseValue}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
